'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 12px 25px 13px 25px;\n  border-bottom: 1px solid ', ';\n'], ['\n  width: 100%;\n  padding: 12px 25px 13px 25px;\n  border-bottom: 1px solid ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0px 5px;\n'], ['\n  margin: 0px 5px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Colors
// Helpers


var Container = _styledComponents2.default.div(_templateObject, _colors.grey);

var Separator = _styledComponents2.default.div(_templateObject2);

var Flex = _styledComponents2.default.div(_templateObject3);

var Buttons = _styledComponents2.default.div(_templateObject4);

var Header = function Header(_ref) {
  var onBack = _ref.onBack,
      selected = _ref.selected,
      onOpen = _ref.onOpen,
      onRemove = _ref.onRemove,
      onShowUploader = _ref.onShowUploader;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Buttons, null, _react2.default.createElement(Flex, null, !!onBack && _react2.default.createElement(Separator, null, _react2.default.createElement(_Button2.default, {
    size: 'small',
    icon: 'arrowleft',
    theme: 'grey',
    onClick: onBack,
    outline: true
  })), selected.length > 0 && _react2.default.createElement(Separator, null, _react2.default.createElement(_Button2.default, {
    size: 'small',
    icon: 'eye',
    theme: 'grey',
    onClick: onOpen
  }, 'Open')), selected.length > 0 && _react2.default.createElement(Separator, null, _react2.default.createElement(_Button2.default, {
    size: 'small',
    icon: 'delete',
    theme: 'grey',
    onClick: onRemove
  }, 'Remove'))), _react2.default.createElement(Flex, null, _react2.default.createElement(Separator, null, _react2.default.createElement(_Button2.default, {
    size: 'small',
    icon: 'plus',
    theme: 'grey',
    onClick: onShowUploader,
    outline: true
  })))));
};

Header.propTypes = {
  onBack: _propTypes2.default.func,
  selected: _propTypes2.default.array,
  onOpen: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  onShowUploader: _propTypes2.default.func
};
exports.default = Header;